import { Radio as AntdRadio } from 'antd';
import type { FC } from 'react';
import { twMerge } from 'tailwind-merge';

interface RadioProps {
  label?: string;
  className?: string;
  [key: string]: any;
}

export const Radio: FC<RadioProps> = ({ label, className = '', ...radioProps }) => {
  return (
    <div className={twMerge('flex items-center gap-2', className)}>
      <AntdRadio {...radioProps} />
      {label && <span className="text-sm">{label}</span>}
    </div>
  );
};

export default Radio;
